import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/site/service-page";
import { localBusinessJsonLd, serviceJsonLd } from "@/components/site/jsonld";
import { SERVICE_PAGES } from "@/lib/site";

const P = SERVICE_PAGES.find((p) => p.slug === "komplett-vask-drammen")!;

export const Route = createFileRoute("/komplett-vask-drammen")({
  head: () => ({
    meta: [
      { title: P.title },
      { name: "description", content: P.desc },
      { property: "og:title", content: P.title },
      { property: "og:description", content: P.desc },
      { property: "og:type", content: "website" },
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(localBusinessJsonLd()) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd(P.h1, P.desc)) },
    ],
  }),
  component: () => <ServicePage slug="komplett-vask-drammen" />,
});
